<template>
    <div id="veehicle_statuses_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
            
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="vehicleStatusHeader" v-if="$route.params.id > 0">Update Asset Statuses</span>
                        <span id="vehicleStatusHeader" v-else>Add Asset Statuses</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackVehicleList" >
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleStatusForm">

                                    <div class="form-group">
                                        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <label class="control-label required" for="code">Code:</label>

                                            <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                            <div class="c-error">{{code_error_msg}}</div>
                                        </div>
                                  <!--  <div class="clearfix"></div> -->
                                
                                        <div class="col-sm-6">
                                        <label class="control-label required" for="name">Name:</label>
                                            <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                            <div class="c-error">{{name_error_msg}}</div>
                                        </div>
                                
                                        <!-- <div class="checkbox col-sm-10">
                                            <div class="color-checkbox-btn checkbox-custome-fl">
                                                <label for="color" >Default
                                                <input type="checkbox" v-model="is_default" id="checked" name="is_default" v-on:click="checkSelected($event)">
                                                
                                                
                                                <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div> -->        
                                        
                                        <div class="col-xs-12">
                                            <div class="checkbox">
                                                <div class="checkbox-custome-fl">
                                                    <label for="color" class="custome-checkbox"> Default
                                                    <input type="checkbox" checked="checked" v-model="color" value="1" id="color" name="color" v-on:click="checkSelected($event)">
                                                    <span class="checkmark"></span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-10">
                                            <div class="radio-button-color">
                                                <div class="row">
                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Silver" v-model="color" name="color">
                                                        <label style="color:#C0C0C0;" for="color">Silver</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Gray" v-model="color" name="color">
                                                        <label style="color:#808080;" for="color">Gray</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Black" v-model="color" name="color">
                                                        <label style="color:#000000;" for="color">Black</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Red" v-model="color" name="color">
                                                        <label style="color:#FF0000;" for="color">Red</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Maroon" v-model="color" name="color">
                                                        <label style="color:#800000;" for="color">Maroon</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Yellow" v-model="color" name="color">
                                                        <label style="color:#FFFF00;" for="color">Yellow</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Olive" v-model="color" name="color">
                                                        <label style="color:#808000;" for="color">Olive</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Lime" v-model="color" name="color">
                                                        <label style="color:#00FF00;" for="color">Lime</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Green" v-model="color" name="color">
                                                        <label style="color:#008000;" for="color">Green</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Aqua" v-model="color" name="color">
                                                        <label style="color:#00FFFF;" for="color">Aqua</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Teal" v-model="color" name="color">
                                                        <label style="color:#008080;" for="color">Teal</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Blue" v-model="color" name="color">
                                                        <label style="color:#0000FF;" for="color">Blue</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Navy" v-model="color" name="color">
                                                        <label style="color:#000080;" for="color">Navy</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Fuchsia" v-model="color" name="color">
                                                        <label style="color:#FF00FF;" for="color">Fuchsia</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>

                                                    <div class="color-radio-btn col-xs-6 col-sm-3 col-md-2 col-lg-2">
                                                        <input type="radio" value="Purple" v-model="color" name="color">
                                                        <label style="color:#800080;" for="color">Purple</label>
                                                        <span class="checkmark"></span>
                                                        <br>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>

                                <!-- <div class="form-group"> -->
                                <div class="col-sm-12 btm-action-btn-fl">
                                    <div class="row">

                                        <button type="submit" id="createVehicleStatusBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateVehicleStatuses" >
                                        <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                        </button>

                                        <button type="submit" id="createVehicleStatusBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateVehicleStatuses" >
                                        <i class="hi-icon icon-flSave"> </i>  Save
                                        </button>
                                        
                                        <button type="submit" id="createAndContinueVehicleStatusBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateVehicleStatuses(flag='Save and Continue')" >
                                        <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                        </button>

                                        <button type="submit" id="cancelVehicleStatusBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackVehicleList" >
                                        <i class="hi-icon icon-flCancel"> </i>  Cancel
                                        </button>

                                    </div>
                                </div>
                                <!-- </div> -->

                                </form>
                            </div>
                        </section>    
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "VehicleStatusesCreate",
  mixins:[commonMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Status | " +process.env.COPYRIGHT_NAME : "Create Asset Status | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    code: "",
    name: "",
    is_default: "",
    color: "",
    checkboxValue: 0,
    loading:false,
    name_error_msg: "",
    code_error_msg: "",
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_status') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            
            self.loadVehicleStatuses();
        }
  },
  methods: {

    BackVehicleList() {
      var self = this;
      self.$router.push("/assetstatuses/list");
    },
    checkSelected: function(e) {
      var self = this;
      if (e.target.checked) {
      
        self.checkboxValue = 1;
      }else{
        self.checkboxValue = 0;
      }
    },
    CreateVehicleStatuses(flag) {
      var self = this;
      self.name_error_msg = "";
      self.code_error_msg = "";
      var error = false;

      self.name = self.name.trim();
      self.code = self.code.trim();

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }
      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleStatusBtn").val("Updating ...");
                $("#createVehicleStatusBtn").prop("disabled", true);
                $("#cancelVehicleStatusBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleStatusBtn").val("Saving ...");
                    $("#createVehicleStatusBtn").prop("disabled", true);
                    $("#createAndContinueVehicleStatusBtn").prop("disabled", true);
                    $("#cancelVehicleStatusBtn").prop("disabled",true);

                }else{

                    $("#createVehicleStatusBtn").val("Saving ...");
                    $("#createVehicleStatusBtn").prop("disabled", true);
                    $("#createAndContinueVehicleStatusBtn").prop("disabled", true);
                    $("#cancelVehicleStatusBtn").prop("disabled",true);
                }
               
            }
            
            $.ajax({
                url: process.env.ROOT_API + "/assetstatuses/create",
                type: "POST",
                data: {name: self.name, is_default: self.checkboxValue, id: segments[3], color: self.color,code: self.code},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleStatusBtn").val("Update");
                        $("#createVehicleStatusBtn").prop("disabled", false);
                        $("#cancelVehicleStatusBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleStatusBtn").val("Save and Continue");
                            $("#createVehicleStatusBtn").prop("disabled", false);
                            $("#createAndContinueVehicleStatusBtn").prop("disabled", false);
                            $("#cancelVehicleStatusBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleStatusBtn").val("Save");
                            $("#createVehicleStatusBtn").prop("disabled", false);
                            $("#createAndContinueVehicleStatusBtn").prop("disabled", false);
                            $("#cancelVehicleStatusBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            self.name = "";
                            self.code = "";
                            self.is_default = "";
                            self.color = "";
                            self.checkboxValue = 0;

                        }else{
                            self.$router.push("/assetstatuses/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleStatusBtn").val("Update");
                        $("#createVehicleStatusBtn").prop("disabled", false);
                        $("#cancelVehicleStatusBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleStatusForm").trigger("reset");
                            
                            $("#createAndContinueVehicleStatusBtn").val("Save and Continue");
                            $("#createVehicleStatusBtn").prop("disabled", false);
                            $("#createAndContinueVehicleStatusBtn").prop("disabled", false);
                            $("#cancelVehicleStatusBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleStatusBtn").val("Save");
                            $("#createVehicleStatusBtn").prop("disabled", false);
                            $("#createAndContinueVehicleStatusBtn").prop("disabled", false);
                            $("#cancelVehicleStatusBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,false,'asset-status-create')
                }
            });
      }
    },

    loadVehicleStatuses() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetstatuses/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.is_default = data.content.is_default;
                    self.color = data.content.color;
                    self.code = data.content.code;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-status-load-by-id')
            }
        });
    },
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/AssetStatusesCreate.vue